import { render, staticRenderFns } from "./V3SideBarGroup.vue?vue&type=template&id=28af7251&scoped=true"
import script from "./V3SideBarGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./V3SideBarGroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./V3SideBarGroup.vue?vue&type=style&index=0&id=28af7251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af7251",
  null
  
)

export default component.exports